<template>
<div class="chapter">
<div class="inner_page">
<h1>Pie Pops</h1>
<div class="toc">
<p>
<b>Table of Contents</b>
</p>
<dl>
<dt>
<span class="chapter">
<span href="#/ch01" title="Link target outside of Sample">Basic Supplies, Tips, &amp; Recipes </span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch01#d0e172" title="Link target outside of Sample">Basic Pie Dough </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch01#icing" title="Link target outside of Sample">Powdered Sugar Icing </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch02" title="Link target outside of Sample">The Pie Pops</span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e237" title="Link target outside of Sample">Bananas Foster </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e280" title="Link target outside of Sample">Banana Cream </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e313" title="Link target outside of Sample">Sensational Spinach </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e350" title="Link target outside of Sample">American Apple Pie </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e383" title="Link target outside of Sample">Dark Chocolate Fudge </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e420" title="Link target outside of Sample">Caramel Apple Pie </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e461" title="Link target outside of Sample">Just Peachy </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e498" title="Link target outside of Sample">Crazy Good Craisin </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e553" title="Link target outside of Sample">Chocoholic </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e586" title="Link target outside of Sample">Lemon Pinnoli </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e629" title="Link target outside of Sample">Apple Havarti </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e662" title="Link target outside of Sample">Razzleberry </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e699" title="Link target outside of Sample">Orange Crème Brûlée </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e745" title="Link target outside of Sample">Spiced Pumpkin </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e792" title="Link target outside of Sample">Aloha </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e831" title="Link target outside of Sample">Lumberjack </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e866" title="Link target outside of Sample">Lemon Meringue </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e907" title="Link target outside of Sample">Ginger Snap Dragon </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e946" title="Link target outside of Sample">J ’Adore </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e989" title="Link target outside of Sample">Cappuccino Crème </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1022" title="Link target outside of Sample">Rocky Road </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1059" title="Link target outside of Sample">Root Beer Float </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1092" title="Link target outside of Sample">Butterscotch </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1135" title="Link target outside of Sample">Berry Luscious </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1178" title="Link target outside of Sample">Yammer </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1225" title="Link target outside of Sample">Grand Pecan </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1268" title="Link target outside of Sample">Kahlúa </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1305" title="Link target outside of Sample">Amaretto </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1345" title="Link target outside of Sample">Mr. Bailey’s </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1382" title="Link target outside of Sample">Margarita Rose </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1417" title="Link target outside of Sample">S’mores </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1456" title="Link target outside of Sample">Green Slime </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1487" title="Link target outside of Sample">Hopscotch </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1516" title="Link target outside of Sample">Oreo </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1557" title="Link target outside of Sample">Nutty Nutella </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1592" title="Link target outside of Sample">Nilla </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1629" title="Link target outside of Sample">Chocolate Turtles </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1672" title="Link target outside of Sample">Tiger’s Blood </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1704" title="Link target outside of Sample">PBJ </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e1731" title="Link target outside of Sample">Spooky </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch03" title="Link target outside of Sample">Metric Conversion Chart</span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01toc.vue?b60c30ca